import React from 'react';

import { IconMailHeart, GradientDot } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * @typedef {RemainingInvitesProps}
 * @property {number} invitesRemaining how many invitations this user has remaining
 */
interface RemainingInvitesProps {
    invitesRemaining: number;
}

/**
 * Shows the user how many invitations they have left and prompts them to invite more users.
 * @param props {InvitesRemainingProps}
 */
export const RemainingInvites = ({
    invitesRemaining,
}: RemainingInvitesProps): JSX.Element => {
    const inviteOrInvites =
        invitesRemaining === 1
            ? locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.INVITE
            : locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.INVITES;

    return (
        <div className="flex flex-col items-center text-center">
            <GradientDot gradientColor="primary" width={180}>
                <div className="relative" style={{ top: 40 }}>
                    <IconMailHeart width={140} fillColor="primary-500" />
                </div>
            </GradientDot>
            <div
                className="rounded-full bg-secondary-500 h-10 w-10 flex items-center justify-center z-10 relative"
                style={{ top: -60, left: 53 }}
            >
                <div className="text-white font-semibold text-lg">
                    {invitesRemaining}
                </div>
            </div>
            <div className="text-lg font-bold mb-3">
                {locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.PART_1}&nbsp;
                <span className="text-secondary-500">{invitesRemaining}</span>
                &nbsp;
                {inviteOrInvites}
                &nbsp;
                {locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.PART_2}
            </div>
            <div>
                {locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.PART_3}&nbsp;
                <span className="font-bold">
                    {locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.PART_4}
                </span>
                &nbsp;
                {locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.CTA.PART_5}
            </div>
        </div>
    );
};
